export const useStyles = () => {
    return {
        container: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            gap: 3,
            height: '100%'
        },
        tableHeader: {
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            width: '100%',
            justifyContent: 'space-between'
        },
        actionHeader: {
            display: 'flex',
            alignItems: 'center',
        },
        switch: {
            gap: 1,
            '& .MuiFormControlLabel-label': {
                fontSize: '14px',
                color: 'c_grey.100',
                width: 'max-content'
            }
        },
        paperRoot: {
            padding: 3,
            marginLeft: '2px',
            height: '100%'
        },
        filter: {
            display: 'flex',
            flexDirection: 'column',
            gap: 1
        }
    }
}